export const dashboard: Dashboard = {
    rowHeight: 175,
    editable: true,
    columns: {
        'xxs': 1,
        'xs': 2,
        'sm': 3,
        'md': 4,
        'lg': 4,
    },
    widgets: [
        {
            module: 'orders',
            name: 'orders.list',
            label: 'orders.index',
            x: 0,
            y: 0,
            height: 2,
        },
        {
            module: 'projects',
            name: 'projects.list',
            label: 'projects.index',
            x: 1,
            y: 0,
            height: 2,
        },
        {
            module: 'organisations',
            name: 'customers.list',
            label: 'customers.index',
            adminOnly: true,
            x: 2,
            y: 0,
            height: 2,
        },
        {
            module: 'contractors',
            name: 'contractors.list',
            label: 'contractors.index',
            adminOnly: true,
            x: 3,
            y: 0,
            height: 2,
        },
        {
            module: 'organisations',
            name: 'general.tableIndex',
            label: 'organisations.tableIndex',
            adminOnly: true,
            x: 0,
            y: 1,
            height: 2,
            props: {
                module: 'organisations',
                detail: 'organisations-id-organisationBaseData',
                infoProp: 'email',
            }
        }],
}

export function getAvailableDashboardWidgets(canAccessAdminWidgets: boolean) {
    return dashboard.widgets.filter((widget) => !widget.adminOnly || canAccessAdminWidgets)
}
